import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: 200px 0; }
`;

const Wrapper = styled.div`
  display: inline-block;
  width: ${({ width }) => width || 'auto'};
  height: ${({ height }) => height || 'auto'};
  position: relative;
`;

const SkeletonWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${({ placeholderWidth }) => placeholderWidth || '100%'};
  height: ${({ placeholderHeight }) => placeholderHeight || '100%'};
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite linear;
  border-radius: 4px;
  opacity: 0.3;
`;

const StyledImage = styled.img`
  display: ${({ loaded }) => (loaded ? 'block' : 'none')};
`;

const PlaceholderImage = ({
  width,
  height,
  borderRadius,
  placeholderWidth,
  placeholderHeight,
  onLoad,
  ...props
}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <Wrapper
      width={loaded ? width : placeholderWidth}
      height={loaded ? height : placeholderHeight}
    >
      {!loaded && (
        <SkeletonWrapper
          placeholderWidth={placeholderWidth}
          placeholderHeight={placeholderHeight}
        />
      )}
      <StyledImage
        width={width}
        height={height}
        loaded={loaded}
        onLoad={event => {
          if (onLoad) onLoad(event);
          setLoaded(true);
        }}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    </Wrapper>
  );
};

export default PlaceholderImage;
